import { isPublic } from '@core/router/utils';
import { Auth } from '@core/auth';

import Investor from '@/models/Investor';

const redirectIncompleteInvestor = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else {
        const auth = Auth();

        if (auth.is_initialised && auth.is_investor && auth.is_owner && to.name === 'Dashboard') {
            const investor = new Investor(auth.investor);

            if (
                investor.is_individual &&
                !investor.adviser_account.is_authorised &&
                !investor.adviser_account.disable_investor_welcome_page
            ) {
                next({ name: 'SettingsIntroduction' });
            } else {
                next();
            }
        } else {
            next();
        }
    }
};

export default redirectIncompleteInvestor;
